import { useState, useCallback, useRef } from 'react';

interface UseSimpleFeedSessionReturn {
  articlesLoadedThisSession: number;
  timeOnPlatform: number;
  recordArticlesLoaded: (count: number) => void;
  resetSession: () => void;
}

/**
 * Simplified session tracking - just counts articles loaded
 * Time is computed on-demand, no complex Intersection Observer needed
 */
export const useSimpleFeedSession = (): UseSimpleFeedSessionReturn => {
  const sessionStartTimeRef = useRef<number>(Date.now());
  const [articlesLoadedThisSession, setArticlesLoadedThisSession] = useState<number>(0);

  const getTimeOnPlatform = useCallback(() => {
    return Math.floor((Date.now() - sessionStartTimeRef.current) / 1000);
  }, []);

  const recordArticlesLoaded = useCallback((count: number) => {
    setArticlesLoadedThisSession(prev => {
      const newTotal = prev + count;
      console.log('[Session] 📊 Articles loaded:', count, '- Total this session:', newTotal);
      return newTotal;
    });
  }, []);

  const resetSession = useCallback(() => {
    console.log('[Session] 🔄 Resetting session');
    setArticlesLoadedThisSession(0);
    sessionStartTimeRef.current = Date.now();
  }, []);

  return {
    articlesLoadedThisSession,
    get timeOnPlatform() {
      return getTimeOnPlatform();
    },
    recordArticlesLoaded,
    resetSession,
  };
};

export default useSimpleFeedSession;

